import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CustomerSupportService } from 'src/app/services/customer-support.service';

@UntilDestroy()
@Component({
  selector: 'app-add-web-viewer',
  templateUrl: './add-web-viewer.component.html',
  styleUrls: ['./add-web-viewer.component.scss'],
})
export class AddWebViewerComponent {
  constructor(
    private dialogRef: MatDialogRef<AddWebViewerComponent>,
    private customerSupportService: CustomerSupportService,
  ) {}

  async addWebViewer(proceed = false): Promise<void> {
    this.dialogRef.close(proceed);
  }

  onOpenLink(link: string) {
    this.customerSupportService.openLink(link);
  }
}
